<template>
  <div class="container-image tw-w-screen" style="height: 834px">
    <div
      class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center xl:tw-px-80 lg:tw-px-40 md:tw-px-20"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <span
        class="tw-text-textMain lg:tw-text-4xl md:tw-text-2xl tw-font-bold tw-mb-4"
        v-html="$t('服务优势')"
      ></span>

      <ul
        class="tw-grid tw-grid-cols-2 tw-gap-20 tw-mt-14 tw-px-10"
        style="max-width: 560px"
      >
        <li class="tw-flex tw-flex-col tw-gap-3">
          <span class="tw-text-textMain tw-font-semibold tw-text-3xl"
            >8000+</span
          >
          <span class="tw-text-textLight">{{
            $t("服务Web3领域项目超过")
          }}</span>
        </li>
        <li class="tw-flex tw-flex-col tw-gap-3">
          <span class="tw-text-textMain tw-font-semibold tw-text-3xl"
            >$ 160亿+</span
          >
          <span class="tw-text-textLight">{{ $t("累计链上交易量超过") }}</span>
        </li>
        <li class="tw-flex tw-flex-col tw-gap-3">
          <span class="tw-text-textMain tw-font-semibold tw-text-3xl"
            >1500万+</span
          >
          <span class="tw-text-textLight">{{
            $t("Web3产品覆盖全球超过")
          }}</span>
        </li>
        <li class="tw-flex tw-flex-col tw-gap-3">
          <span class="tw-text-textMain tw-font-semibold tw-text-3xl"
            >唯一</span
          >
          <span class="tw-text-textLight">{{
            $t("唯一建立完整公链生态类产品布局")
          }}</span>
        </li>
      </ul>
      <!-- <ul class="tw-flex tw-gap-20 tw-mt-12 tw-px-10"></ul> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      observer: null,
      features: [
        {
          iconUrl: "/icons/icon_woshou.png",
          title: "介绍标题1",
          desc: "介绍内容1",
        },
        {
          iconUrl: "/icons/icon_web3.png",
          title: "介绍标题2",
          desc: "介绍内容2",
        },
        {
          iconUrl: "/icons/icon_hegui.png",
          title: "介绍标题3",
          desc: "介绍内容3",
        },
        {
          iconUrl: "/icons/icon_paihang.png",
          title: "介绍标题4",
          desc: "介绍内容4",
        },
        {
          iconUrl: "/icons/icon_renshu.png",
          title: "介绍标题5",
          desc: "介绍内容5",
        },
        {
          iconUrl: "/icons/icon_jiaoyi.png",
          title: "介绍标题6",
          desc: "介绍内容6",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1, // 当组件10%可见时触发
        }
      );

      this.observer.observe(this.$el);
    },
  },
};
</script>

<style scoped lang="scss">
.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}
.container-image {
  background: url("@/assets/home/global-bg.png") no-repeat;
  /* 请替换为实际图片地址 */
  background-size: contain;
  background-position: center;

  position: relative;
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  margin: 10px;
  border-radius: 5px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.46) 0%,
    #ffffff 63%
  );
}

.right-content {
  width: 68%;
  margin-left: 2%;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
  padding-left: 20px;
}

.feature-item {
  padding: 15px 20px;
  width: 33%;
  // margin-bottom: 20px;
}

.feature-icon {
  width: 110px;
  height: 110px;
  margin: 0 auto 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.feature-title {
  font-size: 16px;
  margin-bottom: 10px;
  text-align: center;
}

.feature-desc {
  font-size: 14px;
  color: #666;
}

.border-right {
  border-right: 1px solid #ebebeb;
}

.border-bottom {
  border-bottom: 1px solid #ebebeb;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;

  h4 {
    color: #4077f8;
  }
}

.mr-40 {
  margin-right: 40px;
}
</style>
